import { render, staticRenderFns } from "./AeTreatmentModal.vue?vue&type=template&id=1b2a152b"
import script from "./AeTreatmentModal.vue?vue&type=script&lang=js"
export * from "./AeTreatmentModal.vue?vue&type=script&lang=js"
import style0 from "./AeTreatmentModal.vue?vue&type=style&index=0&id=1b2a152b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports